import React from 'react';

import {type IconProps} from '../icon-props';
import {G, SVG} from '../svg';
import {Border} from './border';
import {type IconComponent} from './icon-component';

interface LightningBoltIconProps extends IconProps {
    background?: string;
    bordered?: boolean;
}

/**
 * @deprecated use MF icons
 */
export const LightningBolt: IconComponent<LightningBoltIconProps> = ({
    bordered = false,
    size = 30,
    fill,
    background,
    ...rest
}) => (
    <SVG size={size} viewBox="0 0 24 24" background={background ? background : 'initial'} {...rest}>
        <G fill={fill || 'white'}>
            {bordered && <Border color={fill} />}
            <path d="M8.763 20.447c-.079 0-.158 0-.158-.079-.157-.079-.236-.237-.157-.395l2.368-6.947H7.5c-.158 0-.237 0-.316-.158a.24.24 0 010-.315l4.184-8.842c.08-.079.158-.158.316-.158h4.421c.158 0 .237.079.316.158a.24.24 0 010 .316l-3.237 5.526H16.5c.079 0 .237.079.316.158.079.158.079.315 0 .394L9.079 20.29c-.079.079-.158.158-.316.158z" />
        </G>
    </SVG>
);
export default LightningBolt;
